import { render, staticRenderFns } from "./saveOrderDivergentModal.vue?vue&type=template&id=a272b708&scoped=true"
import script from "./saveOrderDivergentModal.vue?vue&type=script&lang=js"
export * from "./saveOrderDivergentModal.vue?vue&type=script&lang=js"
import style0 from "./saveOrderDivergentModal.vue?vue&type=style&index=0&id=a272b708&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a272b708",
  null
  
)

export default component.exports